import script from "./DisplayTogglesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayTogglesMenu.vue?vue&type=script&setup=true&lang=js"

import "./DisplayTogglesMenu.vue?vue&type=style&index=0&id=355d9214&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355d9214"]])

export default __exports__